export interface Language {
  code: string;
  label: string;
  english: string;
  flag?: string;
}

export const LANGUAGES: Language[] = [
  { code: 'en', label: 'English', english: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', english: 'Spanish', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', english: 'French', flag: '🇫🇷' },
  { code: 'pt', label: 'Português', english: 'Portuguese', flag: '🇵🇹' },
  { code: 'ru', label: 'Русский', english: 'Russian', flag: '🇷🇺' },
  { code: 'ja', label: '日本語', english: 'Japanese', flag: '🇯🇵' },
  { code: 'it', label: 'Italiano', english: 'Italian', flag: '🇮🇹' },
  { code: 'uk', label: 'Українська', english: 'Ukrainian', flag: '🇺🇦' },
  { code: 'snoop', label: 'Snoop Dog', english: 'Snoop Dog', flag: '🎤' },
];

export const getCurrentLanguage = (): Language => {
  const currentCode = localStorage.getItem('i18nextLng') || 'en';
  return LANGUAGES.find(lang => lang.code === currentCode) || LANGUAGES[0];
};

export const getLanguageByCode = (code: string): Language | undefined => {
  return LANGUAGES.find(lang => lang.code === code);
}; 